export enum Locale {
  ru = 'ru',
  en = 'en'
}
